(() => {
  if (!customElements.get('bn-buybar')) customElements.define('bn-buybar', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const ready = () => this.setup();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true,signal:this.abort.signal});
      else ready();
    }
    setup() {
      this.root = document.getElementById('bn-product-overview-' + this.dataset.section);
      if (!this.root || this.root !== document.querySelector('main product-form.product-info,#content product-form.product-info')) return;
      this.native = this.root.querySelector('.js-product-form [name="add"]');
      this.form = this.root.querySelector('.js-product-form');
      if (!this.native || !this.form) return;
      this.button = this.querySelector('[data-bn-buy]');
      const signal = this.abort.signal;
      const sync = () => {
        const price = this.root.querySelector('.product-price .price__current');
        if (price) this.querySelector('[data-bn-price]').textContent = price.textContent.trim();
        this.button.textContent = this.native.textContent.trim();
        this.button.disabled = this.native.disabled || this.native.getAttribute('aria-disabled') === 'true';
        this.visible();
      };
      this.observer = new MutationObserver(sync);
      this.observer.observe(this.native,{attributes:true,childList:true,subtree:true,characterData:true});
      this.root.addEventListener('on:variant:change', event => {
        const variant = event.detail?.variant;
        this.querySelector('[data-bn-variant]').textContent = this.dataset.defaultVariant === 'true' ? '' : (variant?.title || '');
        sync();
      },{signal});
      const selected = this.root.querySelector('variant-picker')?.variant;
      if (selected && this.dataset.defaultVariant !== 'true') this.querySelector('[data-bn-variant]').textContent=selected.title || '';
      this.button.addEventListener('click', () => {
        if (this.button.disabled) return;
        this.form.scrollIntoView({block:'center',behavior:'instant'});
        this.native.focus({preventScroll:true});
        this.native.click();
      },{signal});
      const schedule = () => {if (!this.frame) this.frame=requestAnimationFrame(()=>{this.frame=0;this.visible();});};
      addEventListener('scroll',schedule,{passive:true,signal});
      addEventListener('resize',schedule,{passive:true,signal});
      sync();
    }
    visible() {
      this.hidden = innerWidth > 767 || this.native.getBoundingClientRect().bottom >= 0;
      document.body.classList.toggle('bn-has-buybar',!this.hidden);
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame);
      document.body.classList.remove('bn-has-buybar');
    }
  });
  const setupDetails = () => document.querySelectorAll('[data-bn-toc]:not([data-built])').forEach(nav=>{
    nav.dataset.built='true';
    const section=nav.closest('.bn-product-editorial');
    const headings=[...section.querySelectorAll('.bn-product-editorial__description h2,.bn-product-editorial__description h3')].filter(h=>h.textContent.trim()).slice(0,8);
    if(headings.length<2)return;
    headings.forEach((heading,index)=>{
      if(!heading.id)heading.id=section.id+'-topic-'+index;
      const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent.trim();nav.append(link);
    });nav.hidden=false;
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupDetails,{once:true});else setupDetails();
  document.addEventListener('shopify:section:load',setupDetails);
})();
